import styled from 'styled-components';

export const BackgroundPickerContainer = styled.div`
  z-index: 10;
  padding: 16px;
  background: #282E33;
  border-radius: 5px;
  color: #B6C2CF;
`;

export const BackgroundButton = styled.button`
  background: none;
  border: none;
  border-radius: 3px;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #B6C2CF;
  width: 100%;
  text-align: left;
  
  &:hover {
    background: #3B444C;
  }
`;

export const BackgroundModal = styled.div`
  margin-top: 8px;
  background: #282E33;
  border-radius: 3px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #22272B;
  }

  &::-webkit-scrollbar-thumb {
    background: #3B444C;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #465059;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const ModalTitle = styled.h4`
  margin: 0;
  color: #B6C2CF;
  font-size: 16px;
  font-weight: 500;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const PickerTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #B6C2CF;
`;

export const SearchContainer = styled.form`
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 2px solid #3B444C;
  border-radius: 3px;
  font-size: 14px;
  background: #22272B;
  color: #B6C2CF;
  
  &::placeholder {
    color: #8C9BAB;
  }
  
  &:focus {
    outline: none;
    border-color: #579DFF;
    background: #22272B;
  }
`;

export const IconButton = styled.button`
  background: #3B444C;
  border: none;
  border-radius: 3px;
  padding: 8px;
  cursor: pointer;
  color: #B6C2CF;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #465059;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  border-bottom: 1px solid #3B444C;
`;

export const TabButton = styled.button`
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 8px 16px;
  cursor: pointer;
  color: ${props => (props.active ? '#579DFF' : '#8C9BAB')};
  font-size: 14px;
  font-weight: ${props => (props.active ? '500' : 'normal')};
  transition: all 0.2s;
  
  &:hover {
    color: #85B4FF;
  }
  
  ${props => props.active && `
    border-bottom: 2px solid #579DFF;
  `}
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  max-height: 60vh;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #22272B;
  }

  &::-webkit-scrollbar-thumb {
    background: #3B444C;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #465059;
  }
`;

export const ColorGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 12px;
    max-height: 60vh;
    overflow-y: auto;
    padding: 12px;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #22272B;
    }

    &::-webkit-scrollbar-thumb {
        background: #3B444C;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #465059;
    }
`;

export const ColorOption = styled.div`
    aspect-ratio: 1;
    background-color: ${props => props.color};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 8px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
        pointer-events: none;
    }

    &::before {
        content: attr(title);
        position: absolute;
        bottom: -24px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: #B6C2CF;
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.2s;
        pointer-events: none;
    }

    &:hover::before {
        opacity: 1;
    }
`;

export const FontColorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 10px;
`;

export const FontColorLabel = styled.label`
  font-size: 14px;
  color: #B6C2CF;
`;

export const FontColorSelect = styled.select`
  flex: 1;
  padding: 8px 12px;
  border: 2px solid #3B444C;
  border-radius: 3px;
  font-size: 14px;
  background: #22272B;
  color: #B6C2CF;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #579DFF;
  }
`;

export const ImageOption = styled.div`
  aspect-ratio: 16/9;
  background-image: url(${props => props.url});
  background-size: cover;
  background-position: center;
  border-radius: 3px;
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
  
  &:hover {
    transform: scale(1.05);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 3px;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    pointer-events: none;
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: #B6C2CF;
  grid-column: 1 / -1;
`;

export const PhotoCredit = styled.div`
  font-size: 12px;
  color: #8C9BAB;
  margin-top: 4px;
  
  a {
    color: #579DFF;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
      color: #85B4FF;
    }
  }
`;
